module.exports = __webpack_public_path__ + "img/snow_fall_00020.41c92483.png";